import {InputModel} from './input-model';

export class FormModel {
  inputs:InputModel[];

  title:string;
  constructor() {
    this.inputs = [];
  }
}
